module.exports = __webpack_public_path__ + "static/media/Steppr loyalty and gifting - Amadeus Jewellery.7dac1995.webp";